import { useContext, useEffect } from "react"
import YouTube from "react-youtube"
import { MultiContext } from "~/contexts/MultiContext"
import { SingleContext } from "~/contexts/SingleContext"
import { useConditionalState } from "~/utils/useConditionalState"
import { useVideoDimensions } from "~/utils/useVideoDimensions"

export function Video() {
  const { videoData, updateVideo, position, focused } = useContext(SingleContext)
  const { layout, controlsEnabled } = useContext(MultiContext)
  const { videoId, player } = videoData
  const setPlayer = (val) => {
    const { author, title } = val.getVideoData()
    updateVideo({ player: val, author, title })
  }
  const origDimensions = useVideoDimensions(position, focused)
  const videoDimensions =
    controlsEnabled && !focused
      ? { height: origDimensions.height, width: origDimensions.height * (16 / 9) }
      : origDimensions

  useEffect(() => {
    if (!player) return

    if (position > layout) {
      player.pauseVideo()
    }
  }, [player, position, layout])

  const durationClass = useConditionalState({
    bool: focused,
    defaultCase: "duration-500",
    trueCase: "duration-0",
  })

  const onPlayerReady = (event) => {
    event.target.mute()
    setPlayer(event.target)
  }

  const opts = {
    ...videoDimensions,
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
      controls: 1,
      fs: 0,
      modestbranding: 1,
      playsinline: 1,
    },
  }

  return (
    <YouTube
      videoId={videoId}
      opts={opts}
      onReady={onPlayerReady}
      iframeClassName={`transition-all ${durationClass} outline-none`}
    />
  )
}
